<div
  cdkDrag
  class="back-to-back-chart-container"
  (cdkDragStarted)="dragStart()"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
    <div class="menu-bar-title">White Label Margin</div>
    <button class="button-close" (click)="onClose()"></button>
  </div>
  <div class="chart-container">
    <ag-charts [options]="chartOptions" class="ag-chart"></ag-charts>
  </div>
</div>
